import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const InclusionExclusionPrinciple = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Principle of Inclusion & Exclusion"
    videos={[
      "https://www.youtube.com/embed/HHlUUhr7e0I"
    ]}
    takeaways={[]}
    questions={[
      "How many positive integers between 1 and 350 (inclusive) are divisible by (i) At least one of 3, 5 and 7 (ii) 3 and 5 but not by 7",
      "How many positive integers between 1000 and 9999 inclusive are divisible by 5 but not by 7",
      "How many positive integers between 100 and 999 inclusive (i) are not divisible by either 3 or 4 (ii) are divisible by 3 but not by 4",
      "How many integers are there between 1 and 1000 inclusive that are divisible by at least one of the integers 2,3,5 and 7",
      "In a survey of 1244 families conducted by a marketing agency in a particular city, the following information was obtained: 520 families have TV, 416 families have DVD Player, 320 families have a computer, 152 families have a TV and a DVD player, 96 families have a TV and a computer, 124 families have a computer and a DVD player, 60 families have all the three. How many families do not have all the three?"
    ]}
    exampleVideos={[]}
  />
);
}

export default InclusionExclusionPrinciple;
